import { BalanceHistoryImpl } from "features/balanceHistory/data/BalanceHistoryImpl";
import { BalanceHistoryViewModel } from "features/balanceHistory/presentation/viewModel/BalanceHistoryViewModel";
import { IBalanceHistoryRepository } from "../domain/repositories/IBalanceHistoryRepository";
import { BalanceHistoryUseCase } from "../domain/useCases/BalanceHistoryUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class BalanceHistoryInjection extends InjectionModule {
  private static readonly balanceHistoryRepositoryToken = Symbol(
    "IBalanceHistoryRepository",
  );
  private static readonly balanceHistoryViewModelToken = Symbol(
    "BalanceHistoryViewModel",
  );
  private static readonly balanceHistoryUseCaseToken = Symbol(
    "BalanceHistoryUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.balanceHistoryRepositoryToken,
      useClass: BalanceHistoryImpl,
    },
    {
      scope: "otherRepo",
      token: this.balanceHistoryUseCaseToken,
      useClass: BalanceHistoryUseCase,
    },
    {
      scope: "viewModel",
      token: this.balanceHistoryViewModelToken,
      useClass: BalanceHistoryViewModel,
    },
  ];

  static getBalanceHistoryRepo(): IBalanceHistoryRepository {
    return this.resolve(this.balanceHistoryRepositoryToken);
  }

  static getBalanceHistoryUseCase(): BalanceHistoryUseCase {
    return this.resolve(this.balanceHistoryUseCaseToken);
  }
}
